<template>
    <div :class="multi ? 'mt-5' : ''">
        <dropdown
            :items="choices"
            :selected="selected"
            :name-key="nameKey"
            :deselect="multi || !field.required"
            :value-key="valueKey"
            :multi="multi"
            :label="title"
            :error-messages="formData.value_error || errorMessages"
            @input="valueChanged"
        ></dropdown>
    </div>
</template>

<script>
import { computed, ref, watch, onMounted } from "@vue/composition-api";
import AppModule from "../../store/modules/app";
import ApiTax from '../../api/billing/tax'
import {formatLanguageLabel} from '@/helpers/formatting'

export default {
    name: "ClassifierChoiceField",
    props: {
        accountId: {
            type: Number,
            default: 0
        },
        field: {
            type: Object,
            required: true
        },
        value: {
            type: [String, Array, Number],
            default: null
        },
        errorMessages: {
            type: String,
            default: null
        },
        inputCssClass: {
            type: String,
            default: ""
        },
        readonly: {
            type: Number,
            default: 0
        },
        activeAndArchivedClientGroups: {
            type: Array,
            default: () => []
        },
        title: {
            type: String,
            default: null
        }
    },
    setup(props, ctx) {
        const { countries, languages, client_groups, taxes } = AppModule();

        const formData = ref({
            value: props.value,
            value_error: null
        });

        const origValue = computed(function() {
            return props.value;
        });

        const getFilteredClientGroups = () => {
            return props.activeAndArchivedClientGroups.filter(clientGroup => {
                if (clientGroup.status === 'active') {
                    return true
                }

                if (Array.isArray(formData.value.value) && formData.value.value.find(clientGroupId => clientGroup.id === clientGroupId)) {
                    return true
                }

                return false
            })
        }

        const multi = computed(() => {
            return props.field.type === 'client_groups'
        })

        const valueKey = computed(() => {
            return props.field.type === 'client_groups' || props.field.type === 'tax_id' ? 'id' : 'code'
        })

        const nameKey = computed(() => {
            return props.field.type === 'tax_id' ? 'description' : 'name'
        })

        const selected = computed(() => {
            if (multi.value) {
                return choices.value.filter(x => (formData.value.value.includes(x[valueKey.value])))
            } else {
                return choices.value.filter(x => x[valueKey.value] === formData.value.value)
            }
        })

        const choices = computed(function() {
            switch (props.field.type) {
                case "country_code":
                    return countries.value;
                case "language":
                    return languages.value.map((item) =>  {
                        // add country codes to different flavors of "English"
                        return {
                            ...item,
                            name: formatLanguageLabel(item)
                        }
                    });
                case "client_groups":
                    return getFilteredClientGroups()
                case "tax_id":
                    return taxes.value[props.accountId] ? taxes.value[props.accountId] : []
                default:
                    return [];
            }
        });

        const valueChanged = function(data) {
            const value = multi.value ? data.map(x => x[valueKey.value]) : data[valueKey.value]
            formData.value.value_error = null;
            formData.value.value = value;
            ctx.emit("change", formData.value.value);
        };

        watch (origValue, function(val) {
            if (formData.value == null) return;
            formData.value.value = val;
            formData.value.value_error = null;
        }, { immediate: true });

        return {
            formData,
            choices,
            valueChanged,
            valueKey,
            nameKey,
            selected,
            multi
        };
    }
};
</script>
